import { Box, styled } from "@mui/material";

export const BlockSpinnerContainer = styled(Box)`
  min-height: 1em;
  width: 100%;
  text-align: center;
  vertical-align: middle;
  display: flex;
  align-items: center;

  .spinner {
    text-align: center;
    flex: 0 0 auto;
    margin-left: auto;
    margin-right: auto;
  }
`;
